import { useEffect, useRef, useState } from 'react'

/** Keep nested annotation/camera portals visible in native browser fullscreen too. */
export function useMediaFullscreen() {
  const [active, setActive] = useState(!!document.fullscreenElement)
  const owned = useRef(false)
  const mounted = useRef(true)

  const toggle = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen()
        owned.current = false
      } else {
        await document.documentElement.requestFullscreen()
        owned.current = true
        if (!mounted.current && document.fullscreenElement) await document.exitFullscreen()
      }
    } catch {
      // The viewport viewer remains usable when native fullscreen is unavailable or denied.
    }
  }

  useEffect(() => {
    const changed = () => {
      setActive(!!document.fullscreenElement)
      if (!document.fullscreenElement) owned.current = false
    }
    document.addEventListener('fullscreenchange', changed)
    return () => {
      mounted.current = false
      document.removeEventListener('fullscreenchange', changed)
      if (owned.current && document.fullscreenElement) document.exitFullscreen().catch(() => undefined)
    }
  }, [])

  return { active, toggle, supported: !!document.fullscreenEnabled }
}
